import { Loader2 } from "lucide-react";

export default function LoadingScreen() {
  return (
    <main
      className="min-h-screen w-full bg-white flex items-center justify-center px-4"
      data-testid="loading-screen"
    >
      <div className="flex flex-col items-center text-center">
        <Loader2
          className="w-10 h-10 text-[#FF4B65] animate-spin"
          data-testid="loading-spinner"
          aria-label="Loading"
        />
        <h2
          className="mt-5 font-display font-bold text-xl sm:text-2xl text-[#111827]"
          data-testid="loading-title"
        >
          Finding your match...
        </h2>
        <p className="mt-2 text-sm text-[#4B5563]" data-testid="loading-subtitle">
          Please wait while we connect you with singles near you.
        </p>
      </div>
    </main>
  );
}
